var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-fullscreen",class:{active:_vm.showImg},on:{"click":function($event){$event.stopPropagation();return _vm.hideFullscreenImg($event)}}},[_c('div',{staticClass:"chat-mask"}),_vm._v(" "),_c('div',{ref:"chatImg",staticClass:"chat-image"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c9e82c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FullscreenImg.vue
// module id = null
// module chunks = 